const SitemapRoutes = {
  getSitemaps: 'gpt/sitemap',
  addSitemap: 'gpt/sitemap',
  uploadSitemap: 'gpt/sitemap/upload?',
  deleteSitemap: 'gpt/sitemap',
  deleteFile: 'gpt/deleteFile',
  uploadFile: 'gpt/file/upload?',
};

export default SitemapRoutes